const Logan = Mach.requireModule('Logan');

const defaultTags = {
  componentId: 'c_special_newborn_page_main',
};

const HomePageLoganType = {
  API: 'HomePageAPI',
  Main: 'HomePageMain',
  Header: 'HomePageHeader',
  PreHeat: 'PreHeatComponent', // 兜底组件
};

function logan(loganType, logData) {
  if (Logan) {
    try {
      const logStr = JSON.stringify({ ...defaultTags, ...logData, loganType });
      if (logStr) {
        Logan.log(logStr);
      }
    } catch (error) {}
  }

  if (Mach.env.isDebug) {
    try {
      const logStr = JSON.stringify({ ...defaultTags, ...logData, loganType });
      console.log(logStr);
    } catch (error) {
      console.log('Logan ❌❌❌❌❌=====', error);
    }
  }
}

export { logan, HomePageLoganType };
